import { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { applyTheme, getTheme } from "../../lib/theme";
import { LandingMotion } from "../marketing/LandingMotion";
import { CONTACT_EMAIL, MarketingFooter, MarketingHeader } from "../marketing/MarketingChrome";
import { HoursCircles } from "../marketing/pitch";
import "../marketing/landing-palette.css";
import "../marketing/word-design.css";
import "./workflow-timeline.css";
export function DataHandlingPage() {
  useLayoutEffect(() => {
    applyTheme("sage-clinic");
    return () => applyTheme(getTheme());
  }, []);
  return (
    <LandingMotion>
      <div data-la-root="" className="wt-page min-h-screen bg-bg">
        <div className="la-pinned-header">
          <div className="la-pinned-header-inner">
            <MarketingHeader />
          </div>
        </div>
        <main className="wt-main relative z-10">
          <div className="wt-intro">
            <h1>How we handle data</h1>
            <p>
              Tarii uses account details, team information, rosters and requests to help your team
              plan shifts and keep members updated.
            </p>
            <div className="wt-circles">
              <HoursCircles />
            </div>
            <h2 className="mt-8 text-xl font-semibold">What we store</h2>
            <p>
              Your email address and display name, team membership and roles, roster assignments,
              leave and preferences, and a record of roster and settings changes.
            </p>
            <h2 className="mt-8 text-xl font-semibold">Who can see it</h2>
            <p>
              Access to team data depends on a person's role in that team. Members use their own
              roster and requests; rosterers use the information needed to plan and manage the
              roster.
            </p>
            <h2 className="mt-8 text-xl font-semibold">Discuss your requirements</h2>
            <p>
              Before a trial, email us at{" "}
              <a className="underline" href={`mailto:${CONTACT_EMAIL}`}>
                {CONTACT_EMAIL}
              </a>{" "}
              to discuss your team's data-handling requirements.
            </p>
            <p>
              Read our{" "}
              <Link className="underline" to="/privacy">
                privacy policy
              </Link>{" "}
              for more detail.
            </p>
          </div>
          <MarketingFooter />
        </main>
      </div>
    </LandingMotion>
  );
}
